export default __webpack_public_path__ + "static/bulbs-5ba41237e9454769322b322ff996b0c8.mp4";